<template>
<nav class="navbar navbar-default navbar-fixed-top">
                <div class="container">
                    <div class="navbar-header">
                        <!-- Collapsed Hamburger -->
                      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#app-navbar-collapse">
                          <span class="sr-only">Menu</span>
                          <span class="icon-bar"></span>
                          <span class="icon-bar"></span>
                          <span class="icon-bar"></span>
                      </button>
                      <!-- Branding Image -->
                      <router-link :to="{ name:  'login' }" class="navbar-brand" v-on:click.native="fecharMenu">
                         <!-- <span id="logo">{{ appName }}</span> -->
                         <span id="logo">PsiquEasy</span>
                      </router-link>
                    </div>


                    <div class="collapse navbar-collapse" id="app-navbar-collapse">

                      <div class="navbar-form navbar-left" v-if="!user">
                          <router-link :to="{ name: 'register' }" active-class="active"
                          v-on:click.native="fecharMenu" class="btn btn-success">
                          {{ $t('register') }}
                        </router-link>
                      </div>
                      <!-- Menu de ferramentas -->
                      <ul class="nav navbar-nav" v-if="userAuthVenc(user)">

                          <li v-show="menu_nav_bar.pacientes == undefined || menu_nav_bar.pacientes == true">
                          <!-- <li > -->
                            <router-link :to="{name:'Pacientes'}" @click.native="fecharMenu">
                              <i class="fa fa-users" aria-hidden="true"></i>
                              <span v-if="termo_paciente.plural">
                                {{ termo_paciente.plural }}
                              </span>
                              <span v-else>Pacientes</span>
                            </router-link>
                          </li>

                          <li v-show="menu_nav_bar.atendimentos == undefined || menu_nav_bar.atendimentos == true">
                            <router-link :to="{name:'Atendimentos'}" @click.native="fecharMenu">
                              <i class="fa fa-address-card-o" aria-hidden="true"></i>
                              <span v-if="termo_atendimento.plural">
                                {{ termo_atendimento.plural }}
                              </span>
                              <span v-else>Atendimentos</span>
                            </router-link>
                          </li>

                          <li v-show="menu_nav_bar.escolas == undefined || menu_nav_bar.escolas == true">
                            <router-link :to="{name:'Escolas'}" @click.native="fecharMenu">
                              <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                              Escolas
                            </router-link>
                          </li>

                          <li v-show="menu_nav_bar.responsaveis == undefined || menu_nav_bar.responsaveis == true">
                            <router-link :to="{name:'Responsaveis'}" @click.native="fecharMenu">
                               <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                              Responsáveis
                            </router-link>
                          </li>

                          <li v-show="menu_nav_bar.testes == undefined || menu_nav_bar.testes == true">
                            <router-link :to="{name:'Testes'}" @click.native="fecharMenu">
                              <i class="fa fa-file-text-o" aria-hidden="true"></i>
                              Testes
                            </router-link>
                          </li>

                          <li v-show="menu_nav_bar.documentos == undefined || menu_nav_bar.documentos == true">
                            <router-link :to="{name:'Documentos'}" @click.native="fecharMenu">
                              <i class="fa fa-book" aria-hidden="true"></i>
                              Documentos
                            </router-link>
                          </li>

                      </ul>

                        <!-- Right Side Of Navbar -->
                        <ul class="nav navbar-nav navbar-right">
                            <!-- Authentication Links -->
                            <template v-if="!user">
                              <!-- <li >
                                <router-link :to="{ name: 'register' }" active-class="active"
                                            v-on:click.native="fecharMenu">
                                     <i class="fa fa-plus" aria-hidden="true"></i>
                                    {{ $t('register') }}
                                </router-link>
                              </li> -->
                              <li>
                                <router-link :to="{ name: 'login' }" active-class="active"
                                            v-on:click.native="fecharMenu">
                                  <i class="fa fa-sign-in" aria-hidden="true"></i>
                                  {{ $t('login') }}
                                </router-link>
                              </li>
                            </template>
                            <li class="dropdown" v-else>
                                <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                                  <!-- <i class="fa fa-user-circle" aria-hidden="true"></i> -->
                                     <!-- {{ user.name | truncate(9, '') }} -->
                                      <!-- <img :src="user.foto | urlImgPerfil" class="img-circle profile-photo"> -->
                                      <div class="row">
                                            <div class="col-xs-1">
                                                  <div class="container-img">
                                                    <div class="avatar-upload">
                                                      <div class="avatar-ico">
                                                        <div id="imagePreview" :style="user.foto | styleImgPerfil">
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                            </div>
                                            <div class="col-xs-10 visible-xs">
                                              <span >
                                                {{ user.name | truncate(10, '') }}
                                                <span class="caret"></span>
                                              </span>
                                            </div>
                                      </div>
                                </a>
                                <ul class="dropdown-menu" role="menu">
                                    <li>
                                       <router-link :to="{ name: 'settings.configs' }" class="dropdown-item pl-3"
                                                    v-on:click.native="fecharMenu">
                                         <fa icon="cog" fixed-width/>
                                         Configurações
                                       </router-link>
                                    </li>
                                    <li>
                                       <router-link :to="{ name: 'settings.profile' }" class="dropdown-item pl-3"
                                                    v-on:click.native="fecharMenu">
                                       <!-- <i class="fa fa-user" aria-hidden="true"></i> -->
                                       <fa icon="user" fixed-width/>
                                       Editar Perfil
                                     </router-link>
                                    </li>
                                    <li>
                                      <a @click.prevent="logout"  href="#" @click="fecharMenu">
                                        <fa icon="sign-out-alt" fixed-width/>
                                        {{ $t('logout') }}
                                      </a>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// import LocaleDropdown from './LocaleDropdown'

export default {

  data: () => ({
    appName: window.config.appName
  }),

  computed:{

    ...mapGetters('auth', ['user']),

    ...mapGetters('config', ['menu_nav_bar', 'termo_atendimento', 'termo_paciente'])

  },

  methods: {

    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },

    //fechar menu do botstrap
    fecharMenu(){
        $(".navbar-collapse").collapse('hide');
    },

    isLog(user){
       return user ?  'navbar navbar-default navbar-fixed-top' : 'navbar navbar-default'
    },

    userAuthVenc(user){

        if (user && user.config) {
                // Hoje
                let dataAtual = moment();
                //30 dias de tolerancia após do vencimento
                let dataBloqueio = moment(user.venc_plano).add(30, 'days')

                return dataAtual > dataBloqueio ? false : true

        }else {
            return false
        }


    }

  }
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/basicos/Navbar.vue